module.exports = __webpack_public_path__ + "static/media/mbank.84257ec1.svg";